
import Vue from 'vue'

const axios = require("axios")
import config from '@/config'


function resetState(state) {
   Object.assign(state, {
      qcuQuestions: {},
      qcuQuestionList: [],
      qcuImages: {},
      qcuQuestion2qcuImageList: {},
      qcuItems: {},
      qcuQuestion2qcuItemList: {},
   })
}

const state = {}
resetState(state)

const mutations = {

   RESET_STATE (state) {
      //console.log('nutrikiosk/RESET_STATE')
      resetState(state)
   },

   SET_QCU_QUESTIONS (state, questions) {
      questions.forEach(question => {
         state.qcuQuestions[question.id] = question
      })
      state.qcuQuestionList = questions.map(question => question.id)
   },

   ADD_QCU_QUESTION (state, question) {
      state.qcuQuestionList.push(question.id)
      Vue.set(state.qcuQuestions, question.id, question)
   },

   UPDATE_QCU_QUESTION (state, question) {
      Vue.set(state.qcuQuestions, question.id, question)
   },

   REMOVE_QCU_QUESTION (state, questionId) {
      // remove it from state.qcuQuestionList
      Vue.delete(state.qcuQuestionList, state.qcuQuestionList.indexOf(questionId))
      // remove it from state.qcuQuestions
      Vue.delete(state.qcuQuestions, questionId)
   },

   SET_QCU_IMAGES (state, { questionId, images }) {
      images.forEach(image => {
         state.qcuImages[image.id] = image
      })
      Vue.set(state.qcuQuestion2qcuImageList, questionId, images.map(image => image.id))
   },

   SET_QCU_ITEMS (state, { questionId, items }) {
      items.forEach(item => {
         state.qcuItems[item.id] = item
      })
      Vue.set(state.qcuQuestion2qcuItemList, questionId, items.map(item => item.id))
   },
}

const actions = {

   GET_QCU_QUESTIONS ({ commit, rootState }) {
      return axios({
         method: 'get',
         url: `${config.QCU_QUESTIONS_URL}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_QCU_QUESTIONS', response.data)
         return response.data
      })
   },
   
   POST_QCUQUESTION ({ commit, rootState }, question) {
      return axios({
         method: 'post',
         url: config.QCU_QUESTIONS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: question,
      })
      .then(function(response) {
         commit('ADD_QCU_QUESTION', response.data)
         return response.data
      })
   },
   
   PUT_QCU_QUESTION ({ commit, rootState }, question) {
      return axios({
         method: 'put',
         url: `${config.QCU_QUESTIONS_URL}${question.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: question,
      })
      .then(function(response) {
         commit('UPDATE_QCU_QUESTION', response.data)
         console.log('PUT_QCU_QUESTION response', response.data)
         return response.data
      })
   },

   DELETE_QCU_QUESTION ({ commit, rootState }, question) {
      return axios({
         method: 'delete',
         url: `${config.QCU_QUESTIONS_URL}${question.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_QCU_QUESTION', question)
         return question
      })
   },

   // fetch qcu images
   GET_QCU_IMAGES ({ commit, rootState }, questionId) {
      return axios({
         method: 'get',
         url: `${config.QCU_IMAGES_URL}?question=${questionId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let qcuImagesDict = { questionId: questionId, images: response.data }
         commit('SET_QCU_IMAGES', qcuImagesDict)
         return qcuImagesDict
      })
   },

   // fetch qcu items
   GET_QCU_ITEMS ({ commit, rootState }, questionId) {
      return axios({
         method: 'get',
         url: `${config.QCU_ITEMS_URL}?question=${questionId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let qcuItemsDict = { questionId: questionId, items: response.data }
         commit('SET_QCU_ITEMS', qcuItemsDict)
         return qcuItemsDict
      })
   },
}

const getters = {
   qcuQuestions: state => state.qcuQuestionList.map(questionId => state.qcuQuestions[questionId])
}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
}



// WEBPACK FOOTER //
// ./src/store/nutrikiosk/index.js